<script setup lang="ts">
import InsuranceUpgrade from '@/components/ui/insurance/InsuranceUpgrade.vue'
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'

const props = defineProps<{
	pageContent: PageContent
}>()
</script>

<template>
	<InsuranceUpgrade :page-content="pageContent" />
</template>
